/**
 * Web Style Import
 *
 */

import './dnb-switch.scss'
